export default __webpack_public_path__ + "static/media/Casino_Spinning_Wheel.97f3b007.mp3";